import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import Meta from "../../components/Meta";
import competitions_data from "../../data/competitions_data";

const Single_competitions = () => {
  const router = useRouter();
  const id = router.query.single_competitions;

  return (
    <div>
      <Meta title={`Competitions`} />

      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- Post --> */}
        <section className="relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          {competitions_data
            .filter((item) => item.id === id)
            .map((item) => {
              const {
                id,
                image,
                title,
                text,
                date,
                time,
                subImages,
                authorImage,
                authorName,
              } = item;

              return (
                <div className="container flex flex-col items-center" key={id}>
                  <header className="mx-auto mb-8 text-center">
                    <h1 className="font-display text-jacarta-700 mb-4 text-2xl dark:text-white sm:text-5xl">
                      {" "}
                      Coinstore Refer & Win!
                    </h1>
                  </header>

                  {/* <!-- Featured image --> */}
                  <figure className="mb-8">
                    <Image
                      width={900}
                      height={550}
                      priority
                      src="/images/competitions/coinstore1.webp"
                      alt="post 1"
                      className="rounded-2xl object-cover"
                    />
                  </figure>

                  {/* <!-- Article --> */}
                  <article className="mb-12 space-y-6 text-center">
                    {/* <!-- Content --> */}
                    <div className="article-content text-[18px] leading-7 text-start">
                      <p>
                        Celebrate with NAMX as they go live for trading on
                        coinstore.com. All you have to do to participate is
                        Sign-Up for an account on Coinstore (if you don’t have
                        one already) by clicking the button below. We can only
                        keep record of your entry if you sign-up or login
                        through the provided link.
                      </p>

                      <p>
                        Once that is complete, purchase any amount of NAMX for
                        yourself to partake in the referral program. You will be
                        provided with a link to share with anyone you chose, if
                        they use your link to sign-up or login to Coinstore and
                        purchase any amount of NAMX for themselves, you will get
                        10% of the amount of NAMX that they purchased as a
                        bonus! Credited right to your Coinstore account.
                      </p>
                      <p>
                        The account that used your referral link has to hold the
                        NAMX that they purchased for at least 7 days. The 10%
                        will be calculated on the average amount that they held
                        during the first 7 days after following your link.
                      </p>
                      <p>
                        Keep an eye on this page as we release more details and
                        announce the competition opening and closing dates.
                      </p>
                    </div>
                    <Link
                      className="inline-block rounded-full bg-white py-3 px-8 text-center font-semibold text-accent shadow-white-volume transition-all duration-500 hover:bg-accent-dark hover:text-white hover:shadow-accent-volume"
                      href="https://www.coinstore.com/"
                    >
                      Lets Go!
                    </Link>
                  </article>

                  {/* <!-- end related --> */}
                </div>
              );
            })}
        </section>
        {/* <!-- end post --> */}
      </div>
    </div>
  );
};

export default Single_competitions;
